import * as _ from 'lodash';
import { environment } from './../../src/environments/environment';
import * as Leaflet from 'leaflet';
// import { CommonLogicService } from './utils/common-logic.service'
class Constant {
    // DateFormatWithTime = 'DD-MM-YYYY HH:mm';
    DateFormatWithTimeHtml = 'DD-MM-YYYY HH:mm';
    DateFormatHtml = 'DD-MM-YYYY';
    timeFormatHtml = 'HH:mm'
    datePickerFormat = 'DD-MM-YYYY HH:mm:ss';
    DateFormat = 'DD-MM-YYYY';
    dateDifferentFormat = 'MM/DD/YYYY';
    DateFormatServerSideDate = "YYYY-MM-DD";
    DateFormatServerSideWithDateTime = "YYYY-MM-DD HH:mm";
    DateFormatServerSideWithDateTimeWithSec = "YYYY-MM-DD HH:mm:ss";
    dashBoardDateFormat = 'DD/MM/YYYY'
    CurrencySymbols = '₹';
    DollarSymbols = '$';
    constructor() {
        // setTimeout(() => {
        //     var formatDateTime: any = JSON.parse(localStorage.getItem(this.localStorage.prefix + this.localStorage.date_time_format));
        //     var currencysymbol = JSON.parse(localStorage.getItem(this.localStorage.prefix + this.localStorage.currency_symbol));
        //     if (!_.isEmpty(formatDateTime)) {
        //         this.datePickerFormat = formatDateTime;
        //         this.DateFormat = formatDateTime.split(" ")[0];
        //     }
        //     if (!_.isEmpty(currencysymbol)) {
        //         this.CurrencySymbols = currencysymbol;
        //     }
        //     if (formatDateTime) {
        //         switch (formatDateTime) {
        //             case 'DD-MM-YYYY HH:mm:ss':
        //                 this.DateFormatWithTimeHtml = 'DD-MM-YYYY HH:mm';
        //                 this.DateFormatHtml = 'DD-MM-YYYY';
        //                 break;
        //             case 'MM-DD-YYYY HH:mm:ss':
        //                 this.DateFormatWithTimeHtml = 'MM-DD-YYYY HH:mm';
        //                 this.DateFormatHtml = 'MM-DD-YYYY';
        //                 break;
        //             case 'YYYY-MM-DD HH:mm:ss':
        //                 this.DateFormatWithTimeHtml = 'YYYY-MM-DD HH:mm';
        //                 this.DateFormatHtml = 'YYYY-MM-DD';
        //                 break;
        //             default:
        //                 this.DateFormatWithTimeHtml = 'DD-MM-YYYY HH:mm';
        //                 this.DateFormatHtml = 'DD-MM-YYYY';
        //                 break;
        //         }
        //     } else {
        //         this.DateFormatWithTimeHtml = 'DD-MM-YYYY HH:mm';
        //         this.DateFormatHtml = 'DD-MM-YYYY';
        //     }
        // }, 4000)
    }
    dateFormatList = [{ date: 'DD-MM-YYYY HH:mm:ss' }, { date: 'MM-DD-YYYY HH:mm:ss' }, { date: 'YYYY-MM-DD HH:mm:ss' }];
    currencyList = [{ countryCode: 'INR', symbol: '₹' }, { countryCode: 'USD', symbol: '$' }];
    paymentList = [{ value: 1, name: 'COD' }, { value: 2, name: 'Online' },];
    logisticsAccount = [{ value: 1, name: 'Own' }, { value: 2, name: 'Others' },];
    agencyTypeList = [{ value: 1, name: 'SAAS' }, { value: 2, name: 'Customer' }];
    codRemittanceTypeList = [{ value: 1, name: 'Central' }, { value: 2, name: 'Store' }];
    InternalError = 'Internal Error';
    PageSize = 20;
    // localhost:40211/user/
    localStorage = {
        prefix: 'adloggs-',
        access: 'access',
        rider_qr_code: 'rider_qr_code',
        address: 'address',
        role_name: 'role_name',
        fixed_price: 'fixed_price',
        disable_rider_price_in_app: 'disable_rider_price_in_app',
        icon_url: 'icon_url',
        logo_url: 'logo_url',
        currency_symbol: 'currency_symbol',
        date_time_format: 'date_time_format',
        price_per_km: 'price_per_km',
        min_km_price: 'min_km_price',
        min_km: 'min_km',
        dp_url: 'dp_url',
        white_label: 'white_label',
        user_role_id: 'user_role_id',
        lat: 'lat',
        long: 'long',
        token: 'token',
        user_name: 'user_name',
        user_id: 'user_id',
        role_id: 'role_id',
        last_name: 'last_name',
        first_name: 'first_name',
        email: 'email',
        phone: 'phone',
    };
    Filter = {
        order: 1,
        user: 2
    }
    expect_km = {
        max_km: 30,
    }
    RoleId = {
        superAdmin: 1,
        admin: 2,
        masterAgency: 4,
        agency: 5,
        vendor: 6,
        vendorAgency: 10,
        employee: 3,
        deliveryStaff: 7,
        orderingPartner: 9,
        thirdpl: 11,
    }
    OrderStatusId = {
        created: 1,
        pending: 2,
        assigned: 3,
        pickedUp: 4,
        delivered: 5,
        cancelled: 6,
        deleted: 7,
        arrived: 8,
        outForDelivery: 9,
        arrivedAtPickup: 11,
        undelivered: 10,
        // returned: 14,
        systemFinished: 15,
        accepted: 20,
        inProgress: 21,
        completed: 22,
        hold: 12,
        ReturnStart: 13,
        rtoDelivered: 14,
        rtoDisposed: 16,
    }
    OrderStatusName = {
        1: "Created",
        2: "Pending",
        3: "Assigned",
        4: "Picked-up",
        8: "Arrived",
        5: "Delivered",
        6: "Cancelled",
        7: "Deleted",
        9: "Out for delivery",
        13: "Return Start",
        14: "RTO-Delivered",
        10: 'Undelivered',
        11: 'Arrived at pickup',
        15: 'System Finished',
        16: 'RTo-Disposed',
        12: 'Hold',
        20: 'Accepted',//just static add me for ondc
        21: 'In-progress',//just static add me for ondc
        22: 'Completed',//just static add me for ondc
    }
    respondentAction = [{ name: "PROCESSING", id: 1 }, { name: "CASCADED", id: 2 }, { name: "NEED-MORE-INFO", id: 4 }, { name: "RESOLVED", id: 3 }];
    resolutionActionTriggered = [{ name: "REPLACEMENT", id: 2 }, { name: "CANCEL", id: 3 }, { name: "NO-ACTION", id: 4 }, { name: "REFUND", id: 1 },];
    orderPriceFrom = [{ name: 'Customer' }, { name: '3PL' }, { name: 'Compare highest' }];
    walletPerference = [{ name: 'Own' }, { name: 'Agency' }, { name: 'Master Agency' }];
    dpAssignMethod = [{ name: 'Preferred' }, { name: 'Parallel' }];
    issueStatus = [{ name: 'Pending', id: 1 }, { name: 'Processing', id: 2 }, { name: 'Refunded', id: 3 }, { name: 'Decline', id: 4 }]
    repeatOrderRemoveMaId = [758, 958, 483, 618]

    typeOf = {
        agency: 'SAAS',
        group: 'Customer'
    }
    current_loop = 10; //add new loop count not used partnerId

    GoogleMap = {
        baseLat: 44.6476,
        baseLong: -63.5728,
        mapZoom: 15
    }
    cryptoJs = {
        algorithm: 'aes-128-cbc',
        secretKey: 'adloggsangular&5&secret@mission'
    }

    tagList = [{ id: 1, name: "Customer" }, { id: 2, name: "City" }, { id: 3, name: "State" }, { id: 4, name: "Store" }, { id: 5, name: "Master Agency" }, { id: 6, name: "Agency" }, { id: 7, name: "3PL" }];
    googleMarkerIcon = {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: "#FF0000",
        fillOpacity: 1,
        strokeWeight: 1,
        scale: 1,
    }
    mapIcons = {
        vendorIcon: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/storeMap.svg',
            iconSize: [64, 64],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        rider: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/rider.png',
            iconSize: [35, 76],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        }),
        adRider: new Leaflet.Icon({
            iconUrl: 'https://dev.adloggs.com/appimg/ad_bike.png',
            // iconSize: [35, 41],
            // iconAnchor: [12, 41],
            // popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        blueIcon: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/marker-blue.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        timeShowIcon: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/blue_dot.png',
            iconSize: [14, 14],
            // iconAnchor: [12, 41],
            // popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        redIcon: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/marker-red.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        startIcon: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/marker-start.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        endIcon: new Leaflet.Icon({
            iconUrl: 'assets/images/icons/marker-end.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            // shadowSize: [41, 41]
        }),
        // iconDarkBlue: Leaflet.divIcon({
        //     className: "marker",
        //     html: this.svgDarkBlue,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
        // iconDarkGreen: Leaflet.divIcon({
        //     className: "marker",
        //     html: this.svgDarkGreen,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
        // iconLightBlue: Leaflet.divIcon({
        //     className: "marker",
        //     html: this.svgLightBlue,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
        // iconLightOrange: Leaflet.divIcon({
        //     className: "marker1",
        //     html: this.svgLightOrange,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
        // iconLightGreen: Leaflet.divIcon({
        //     className: "marker2",
        //     html: this.svgLightGreen,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
        // iconLightPurple: Leaflet.divIcon({
        //     className: "marker3",
        //     html: this.svgLightPurple,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
        // iconLightRed: Leaflet.divIcon({
        //     className: "marker4",
        //     html: this.svgLightRed,
        //     iconSize: [80, 80],
        //     iconAnchor: [12, 24],
        //     popupAnchor: [7, -16]
        // }),
    }
    bikeMakerSvg = {
        // path: "m484.827 157.974h-86.825c-14.983 0-27.173 12.196-27.173 27.188v99.934h-32.476c1.805-6.561 2.474-14.3 2.035-23.306v-.001c-.705-38.059-7.611-70.135-20.528-95.337-10.03-19.567-21.735-31.298-31.779-38.311 11.789-12.121 18.605-29.364 18.605-49.251 0-35.781-28.543-64.89-63.626-64.89s-63.626 29.109-63.626 64.89c0 4.143 3.358 7.5 7.5 7.5h5.096c-.469 2.83-.719 5.714-.719 8.643 0 25.216 18.018 46.291 41.84 51.014-2.497 9.272-3.738 20.205-3.733 32.625l-18.706 16.089-45.515 3.681-52.503-17.356c-4.812-1.6-10.266-3.408-14.998.004-4.663 3.365-4.663 9.256-4.663 11.191v39.035c0 4.143 3.358 7.5 7.5 7.5h8.929l-13.695 47.324c-1.151 3.978 1.141 8.138 5.12 9.289 3.981 1.157 8.138-1.141 9.29-5.119l14.902-51.494h21.322c-26.52 80.872-11.388 134.854 11.871 189.485h-13.482l-56.153-62.786 11.874-41.02c1.152-3.979-1.14-8.138-5.119-9.289s-8.138 1.141-9.29 5.119l-11.357 39.237c-35.126-.586-66.546 23.632-74.553 58.475-.927 4.036 1.592 8.06 5.627 8.988l10.647 2.45c-2.72 28.252 15.885 54.907 44.259 61.438 4.309.993 8.655 1.483 12.971 1.483 10.644 0 21.101-2.984 30.35-8.781 10.855-6.802 18.943-16.802 23.32-28.62l8.401 1.933c2.503.579 4.877.872 7.249-.405 2.207-1.188 3.674-3.333 4.224-5.754.528-2.455.93-4.95 1.209-7.468h156.858c5.016 31.187 31.551 54.696 63.242 54.696s58.227-23.509 63.243-54.696h5.724s1.136.013 1.395.013c2.145 0 5.243-.238 7.787-2.826 1.273-1.295 2.767-3.612 2.652-7.293-.211-7.043-1.268-13.848-3.072-20.316 5.974-36.268.226-58.357-8.295-75.644 5.387-3.531 8.959-9.615 8.959-16.527v-20.613h37.883c14.983 0 27.173-12.196 27.173-27.188v-87.746c.002-14.991-12.187-27.187-27.171-27.187zm-388.746 312.933c-9.601 6.017-20.961 7.93-31.989 5.391h-.001c-20.298-4.672-33.84-23.285-32.853-43.411l81.353 18.724c-3.366 7.925-9.061 14.628-16.51 19.296zm37.528-29.866-116.665-26.846c9.003-24.654 33.231-40.974 59.714-39.57l57.151 63.901c-.05.843-.116 1.681-.2 2.515zm113.285-130.695c-2.177 5.742-2.177 12.821-2.177 22.62v28.302h-27.463v-38.828c0-43.898 23.958-51.721 34.71-53.012h73.529c-.296 9.963-2.544 17.045-6.812 21.54-4.974 5.238-13.485 7.79-26.021 7.802l-26.921.028c-9.6.001-15.94 3.885-18.845 11.548zm-2.177 65.921v17.908c-.068 0-.138 0-.21 0h-53.273c.599-5.554 2.329-9.852 5.17-12.826 4.226-4.422 10.178-5.082 13.35-5.082zm80.445-121.838h-68.207c-2.739-8.619-5.181-18.057-7.189-27.757l20.737-13.46c11.32-7.351 17.209-17.738 16.157-28.499-.932-9.539-7.417-18.06-16.521-21.707-8.314-3.33-17.263-2.284-25.172 2.773.652-7.174 1.866-13.578 3.622-19.014 3.197-.33 6.372-.955 9.49-1.872 6.347-1.474 12.212-3.823 17.507-6.938 14.445 8.63 46.215 36.622 49.576 116.474zm-130.179-183.038c3.537-23.964 23.749-42.39 48.077-42.39 26.812 0 48.626 22.381 48.626 49.89 0 22.374-10.729 40.407-28.029 48.343v-39.463c0-6.833-2.615-15.215-15.069-16.349-.226-.021-.453-.031-.68-.031zm11.329 23.643c0-2.96.337-5.851 1-8.643h40.228c.463.05.801.104 1.043.153.039.278.073.678.073 1.227v43.876c-1.787.263-3.585.396-5.382.397-.017 0-.034 0-.05 0-20.356-.019-36.912-16.614-36.912-37.01zm-9.723 115.92 17.764-1.437c1.583-.127 3.084-.754 4.289-1.789l32.06-27.575.005-.005c3.1-2.671 6.409-4.041 9.631-4.041 1.434 0 2.851.272 4.224.822 3.963 1.587 6.777 5.215 7.171 9.241.495 5.067-2.843 10.203-9.396 14.459l-35.725 23.188h-30.021v-12.863zm-31.696 2.564 16.696-1.35v11.651h-19.401c-2.515 0-3.128-2.09-3.2-3.843-.041-.994.053-5.978 5.905-6.458zm-17.751-5.178c-2.259 3.704-3.314 8.037-3.141 12.25.045 1.091.184 2.142.378 3.166 0 .021-.012.042-.008.062h-36.336v-28.473l39.136 12.937c-.012.02-.018.039-.029.058zm15.088 30.478h66.601c1.449 0 2.868-.42 4.083-1.209l3.395-2.204c1.633 7.218 3.493 14.242 5.519 20.876-15.296 4.515-39.575 19.106-39.575 66.158v39.581c-5.262 1.062-11.487 3.516-16.694 8.965-5.489 5.744-8.624 13.527-9.376 23.189h-15.13c-15.246-43.938-21.044-90.694 1.177-155.356zm12.362 189.458c-2.772-6.375-5.444-12.726-7.96-19.101h77.874c10.093 0 15.21-4.595 15.21-13.656v-26.752-28.302h59.199c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-59.145c.096-4.26.369-7.744 1.15-9.802.379-1.001.707-1.865 4.826-1.865l26.928-.028c16.865-.016 28.93-4.096 36.885-12.474.368-.388.716-.795 1.065-1.2h47.706 53.615v20.613c0 2.578-2.173 4.756-4.745 4.756h-74.665c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h70.258c5.928 11.003 11.26 24.694 10.943 46.325-14.838-20.611-38.859-33.864-66.121-33.864-21.894 0-42.438 8.588-57.849 24.183-13.675 13.837-21.888 31.796-23.578 51.192zm193.958 54.723c-23.446 0-43.22-16.893-48.004-39.696h96.008c-4.785 22.801-24.559 39.696-48.004 39.696zm56.524-54.696h-113.046-10.775c3.682-33.913 32.038-60.377 66.362-60.377 30.135 0 55.442 19.871 63.823 47.688.027.088.054.176.084.263 1.185 3.991 2.022 8.145 2.475 12.426zm71.926-155.395c0 6.721-5.461 12.188-12.173 12.188h-98.998v-38.731h111.171zm0-41.543h-111.171v-15.951h111.171zm0-30.951h-111.171v-15.252c0-6.721 5.461-12.188 12.173-12.188h86.825c6.712 0 12.173 5.468 12.173 12.188z",
        path: 'M28.84,12.93l4.75,0.09L23.08,47.67c1.45,0.36,2.82,0.79,4.11,1.28c-1.27-0.48-2.61-0.9-4.03-1.26 C13.94,45.62,6.32,48.64,0,55.82l7.87,3.71l33.43,15.77c0.26-2.05,0.38-3.97,0.34-5.78c0.01,0.26,0.03,0.53,0.03,0.8h38.37 c0.01,8.23,6.69,14.89,14.92,14.89s14.91-6.67,14.92-14.89h12.56c0.87-17.07-7.19-30.2-21.31-31.46h19c1.51,0,2.74-1.24,2.74-2.74 v-3.01c0-1.49-1.22-2.7-2.7-2.7h-0.24V9.79c0-1.35-1.11-2.46-2.46-2.46h-35.4c-1.35,0-2.46,1.11-2.46,2.46V30.4h-17.5 c-1.85-0.06-2.83,0.78-2.84,2.63v5.84h0v3.82c7.88,6.2,9.08,15.89,1.89,21.35H49.5c-0.3-9.29-5.61-14.95-14.43-21.21l5.26-16.21 c2.17-5.04,0.74-8.86-2.43-11.53c0.99-3.18,1.7-5.9,1.48-8.12l5.51,1.14c1.79,0.37,2.25,1.01,2.83-0.72 c0.1-0.3,0.18-0.59,0.23-0.89c0.45-2.37,0.17-2.21-1.75-2.58l-5.88-1.14h-1.75l-2.16-1.21c-1.29-0.74-2.63-1.18-4-1.36l-1.89-0.12 c-1.94,0-4.12-0.54-5.24,1.25c-0.02,0.03-0.03,0.14-0.04,0.3c-0.79,0.27-1.47,0.86-1.98,1.67c-0.63,0.98-1.01,2.32-1.01,3.78 c0,1.46,0.39,2.8,1.01,3.78c0.7,1.1,1.71,1.8,2.87,1.83C26.8,13.18,27.86,12.91,28.84,12.93L28.84,12.93L28.84,12.93z M103.13,24.37h12.46v2.19h-12.46V24.37L103.13,24.37z M93.66,9.48h9v9.78l-4.72-3.66l-4.28,3.66V9.48L93.66,9.48z M103.13,30.07 h12.46v2.19h-12.46V30.07L103.13,30.07z M7.91,59.56l13.3,6.3l-4.32-1.98c-2.97,0.63-5.19,3.27-5.19,6.42 c0,3.63,2.94,6.57,6.57,6.57c3.63,0,6.57-2.94,6.57-6.57c0-1.12-0.28-2.17-0.77-3.1l9.08,4.3c-0.61,7.68-7.04,13.72-14.87,13.72 c-8.24,0-14.92-6.68-14.92-14.92C3.34,66.08,5.09,62.27,7.91,59.56L7.91,59.56L7.91,59.56z M25.27,4.2 c0.06,1.92,0.19,4.39,0.28,6.05c-0.16-0.14-0.32-0.32-0.46-0.55c-0.42-0.65-0.67-1.58-0.67-2.62s0.26-1.97,0.67-2.62 C25.15,4.37,25.21,4.28,25.27,4.2L25.27,4.2z M88.4,70.32h13.14c-0.01,3.62-2.95,6.54-6.57,6.54S88.41,73.94,88.4,70.32L88.4,70.32 L88.4,70.32z',
        fillColor: '#FF0000',
        fillOpacity: 1,
        anchor: null,
        strokeWeight: 0,
        scale: 0.5,
    }

    errOrFalseRes = {
        data: [],
        pagination: {
            totalRows: 0,
            rowSize: 10,
            currentPage: 1
        }
    }
    Client = {
        Auth: {
            BaseUrl: environment.Service.AuthBaseUrl,
        }
    }
    Service = {
        MainMaster: {
            BaseUrl: environment.Service.AdloggsApiBaseUrl,
            AdloggsApiUrl: environment.Service.AdloggsApiUrl,
            AdloggsApikey: environment.Service.AdloggsApikey,
            // trackUrl: environment.Service.trackUrl,
            // onboardUrl: environment.Service.onboardUrl,
            Auth: {
                Login: 'user/login',
                Logout: 'user/logout',
                session: 'user/createsession'
            },
            Dashboard: {
                SuperAdmin: 'dashboard/superadmin',
                SuperAdminDayWise: 'dashboard/superadmin/daywise',
                Vendor: 'dashboard/vendor',
                VendorAgency: 'dashboard/vendoragency',
                Agency: 'dashboard/agency',
                masterAgency: 'dashboard/masteragency',
                weatherReportApi: 'dashboard/vendoragency/getweather'
            },
            User: {
                Create: 'user',
                Update: 'user',
                GetAll: 'user',
                GetById: 'user/',
                Session: 'user/session/json',
                emailCheck: 'user/check/email',
                PhoneCheck: 'ds/check/phone',
                DesktopUpdateToken: 'user/updateuser/own',
                UserExport: 'user/users/export',
                OrderForceAssign: 'user/child/dsforceassign'
            },
            Order: {
                Create: 'order',
                BulkCreate: 'order/bulk',
                OfflineOrder: 'order/bulk/offline',
                GetAll: 'order/list',
                GetAllNewApi: 'v110/order/list',
                GetById: 'order/',
                GetByIdNewApi: 'v110/order/',
                dpAllocatedApi: 'v110/order/allocated3pl/',
                Export: 'v110/order/list/export',
                Update: 'order',
                Repeat: 'order/repeat',
                Pagination: 'order',
                OrderStatus: 'order/ds/assign',
                OrderCount: 'order/status/count',
                SheduleOrder: 'order/bulk',
                SheduleOrderList: 'cluborder/list',
                SheduleOrderId: 'cluborder/getone',
                updateSingleField: 'order/update',
                // updateSheduleOrder: 'order/update/bulkstatus',
                updateSheduleOrder: 'cluborder/update/orderstatusandkmtime',
                AutoRouteOptimizer: 'cluborder/route/optimizer',
                sheduleOrderExcel: 'cluborder/export/tripsheet',
                TrackOrder: 'erranderz/trackorder',
                TrackOrderRefresh: 'erranderz/trackrefresh',
                OpenOrder: 'order/openorders',
                UpdateOpenOrders: 'order/agencyassign',
                HumanOrGoogle: 'cluborder/assign/humanorgoogle',
                UnAssignOrder: 'cluborder/assign/unassignone',
                Cancel: 'order/cancel',
                IssueComment: 'order/comment',
                IssueCommentGetById: 'order/comment/getbyid',
                ServiceAbility: 'dporder/check/serviceability'
            },
            DeliveryPartnerWiseOrderTime: {
                DpOrderMap: 'dporder/usermap',
                DpOrderGetMap: 'dporder/getusermap',
                DeleteDp: 'dporder/usermap/delete'
            },
            DeliveryPartner: {
                UserDbCredentialUpdateOrCreate: 'dporder/dpcredential',
                // DeliveryPartnerUpdate:'dporder/dpcredential',
                GetByIdUserDpCredential: 'dporder/getuserdpcredential',
                GetAllUserDpCredential: 'dporder/getalluserdpcredential'
            },
            OrderingPartnerMap: {
                OrderinPartnerVendorMap: 'opuser/vendormap',
                OrderingPartnerGetMap: 'opuser/getusermap'
            },
            // role,city,state,country,category,vehicle
            Dynamic: {
                getAll: 'dynamic',
                GetOne: 'dynamic/',
            },
            DeliveryStaff: {
                Create: 'ds',
                MapToUserCreate: 'ds/maptouser/create',
                MapToUser: 'ds/maptouser/',
                Update: 'ds',
                GetAll: 'ds',
                GetById: 'ds/',
                GetNear: 'ds/currentlocation/getnear',
                DsSettlement: 'dssettlement/daily/vendorlist',
                MapShowCurrentLocation: 'ds/currentlocation/getwithcurrentstatus',
                RiderLocation: 'ds/currentlocation/getriderhistory',
                VendorMapping: 'ds/maptouser/create',
                GetDailyDeployment: 'ds/dailydeployment',
                CreateDailyDeployment: 'ds/dailydeployment/create',
                GetByOneDailyDeployment: 'ds/dailydeployment/getbyone',
                AttendanceExport: 'ds/attendance/export',
                RiderCurrentLocation: 'ds/currentlocation/forvendor',
                DsExport: 'ds/export',
                RiderOrderAttendanceExport: 'ds/dailydeployment/export',
                MgRiderOrderCountExport: 'mgreport/admin/ds/deploy/export'
            },
            City: {
                Create: 'city',
                Update: 'city',
                CheckCity: 'city/checkavailable',
                CheckAgecncyArea: 'city/check/agencyarea',
                AddCity: 'city/createfromtext'
            },
            AreaAllocate: {
                AreaId: 'user/area'
            },
            Priceandtax: {
                Create: 'price',
                GetAll: 'price',
                GetById: 'price/',
                Update: 'price'
            },
            Commission: {
                Create: 'commission',
                Update: 'commission',
                GetById: 'commission/',
                GetAll: 'commission'
            },
            InvoiceManagement: {
                Invoice: 'invoice',
                ExportExcel: 'invoice/export/excel/',
                VendorInvoice: 'vendorinvoice/list',
                dsSettlementLive: 'dssettlement/daily/live',
                VendorInvoiceExcel: 'vendorinvoice/exportorderlist',
                PayStatusUpdate: 'vendorinvoice/update',
                VendorInvoiceMaxKmExcel: 'orderreport/export/expectedmaxkm',
                VendorMgInvoice: 'vendorinvoice/vendor/mg',
                ZohoInvoice: 'vendorinvoice/zoho/export'
            },
            Payment: {
                dsPayment: 'dspayment',
                UpdatePayment: 'dspayment/update',
                DsAdjustment: 'dspayment/adjustments/getall',
                AdjustmentsPayment: 'dspayment/adjustments',
                AdloggsPayment: 'invoice/payment/list',
                ExportExcel: 'dspayment/export/excel/',
                AgencyPayment: 'deliverychargetoagency/list',
            },
            Report: {
                dsSettlementCodeVerify: 'dssettlement/daily/getverifycode',
                dsOrderNotification: 'ds/ordernotify/list',
                vendorWiseReport: 'orderreport/vendorwise',
                excessKm: 'order/excesskm',
                dateWiseDeliveryStaff: 'dspayment/datewise/single',
                datewiseDsList: 'dspayment/datewise',
                VendorInvoiceFilters: 'vendorinvoice/filter/dynamic',
                VendorInvoiceSingle: 'vendorinvoice/single/dynamic',
                dpCodOrderReport: 'orderreport/3pl/codlist',
                mgReport: 'mgreport/admin/ds/list',
                orderAdjustment: 'v110/order/adjestment',
                order: {
                    orderExport: 'orderreport/list/export',
                    orderReport: 'orderreport/list',
                    issueCommentGetAll: 'order/comment/getall',
                    OrderReportPerformance: 'orderreport/performance',
                    importExcel: 'orderreport/exportfromexcel',
                    codReport: 'orderreport/cod/list',
                },
                Filter: {
                    GetTemplate: 'filter/get/',
                    Create: 'filter/create',
                    Delete: 'filter/delete'
                },
            },
            Wallet: {
                GeneratePaymentLink: 'wallet/paylink',
                walletList: 'wallet/transection/list',
                userWalletPaidlist: 'wallet/userpaidlist'
            },
            PartnerApi: {
                OpUser: 'opuser/generateapikey'
            },
            LoginLink: {
                link: 'user/childsession'
            },
            Ondc: {
                getAll: 'igm/getall',
                getById: 'igm/',
                comment: 'igm/comment',
                orderGetAll: 'order/list',
                orderExport: 'orderreport/monthly/export',
                rsplist: 'rsp/getall',
                issueOrderGet: 'igm/orderdtls',
                orderCancel: 'order/cancel',
                getBuyerList: 'buyer/list',
            },
            Developer: {
                Webhookurl: 'user/webhook/getone',
                CreateWebhook: 'user/webhook/create',
            },
            Adloggs: {
                adloggsOrderGet: 'oporder/igm/',
            }
        },
    }
    Style = [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#EBE3CD"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#523735"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#F5F1E6"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#C9B2A6"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#DCD2BE"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#AE9E90"
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#DFD2AE"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#DFD2AE"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#93817C"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#A5B076"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#447530"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#F5F1E6"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#FDFCF8"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#F8C967"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#E9BC62"
                }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#E98D58"
                }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#DB8555"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#806B63"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#DFD2AE"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#8F7D77"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#EBE3CD"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#DFD2AE"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#B9D3C2"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#92998D"
                }
            ]
        }
    ]
    riderLocationMapDesign = [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#F5F5F5"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#F5F5F5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#BDBDBD"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#EEEEEE"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#E5E5E5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9E9E9E"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#FFFFFF"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#DADADA"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9E9E9E"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#E5E5E5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#EEEEEE"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#C9C9C9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9E9E9E"
                }
            ]
        }
    ]
    Permission = {
        "trackOrder": {
            "access": false
        },
        "quickOrder": {
            "access": false
        },
        "superAdminDashboard": {
            "access": true
        },
        "masters": {
            "access": true,
            "admin": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "customerMaster": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "customerGroup": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "masterAgency": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "agency": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "vendor": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "deliveryStaff": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "vendorAgency": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            }
        },
        "order": {
            "access": true,
            "liveOrder": {
                "access": true,
                "add": false,
                "edit": true,
                "delete": false
            },
            "multipleOrder": {
                "access": false,
                "add": false,
                "edit": false,
                "delete": false
            },
            "scheduleOrder": {
                "access": false,
                "add": false,
                "edit": false,
                "delete": false
            },
            "offlineOrder": {
                "access": false,
                "add": false,
                "edit": false,
                "delete": false
            }
        },
        "report": {
            "access": true,
            "order": {
                "access": true,
                "basicOrder": {
                    "access": true,
                    "repeat": true
                },
                "issueOrder": {
                    "access": true,
                    "add": false,
                    "edit": true,
                    "delete": false
                },
                "customerWiseOrder": {
                    "access": true
                },
                "orderAnalytics": {
                    "access": true
                },
                "codOrder": {
                    "access": true
                },
                "3plCodOrder": {
                    "access": true
                },
                "riderMg": {
                    "access": true
                },
                "deliveryStaff": {
                    "access": false
                }
            },
            "dsOrderNotification": {
                "access": false
            },
            "transactionReport": {
                "access": true
            }
        },
        "receivables": {
            "access": true,
            "masterAgency": {
                "access": true
            },
            "agency": {
                "access": true
            },
            "vendor": {
                "access": true
            }
        },
        "payment": {
            "access": true,
            "maDeliveryCharge": {
                "access": true
            },
            "aDeliveryCharge": {
                "access": true
            }
        },
        "pricingAndTax": {
            "access": true,
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "agency": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "deliveryStaff": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            }
        },
        "settings": {
            "access": true,
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "packages": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            },
            "countries": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            },
            "states": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "districts": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            },
            "cities": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            },
            "vehicle": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            },
            "Announcement": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            },
            "offers": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            },
            "sms": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true,
                "view": true
            }
        },
        "customerSupport": {
            "access": true,
            "feedback": {
                "access": true,
                "add": true,
                "edit": true,
                "delete": true
            }
        },
        "riderMap": {
            "access": true
        },
        "ondc": {
            "access": true,
            "orderList": {
                "access": true
            },
            "igm": {
                "access": true
            },
            "rsp": {
                "access": true
            }
        }
    };
    map = {
        mapsUrl: 'https://maps.googleapis.com/maps/api'
    };
}
let constant = new Constant();
export default constant;
